module.exports = __webpack_public_path__ + "img/Patch16-2.abf3bff8.webp";